import { render, staticRenderFns } from "./serviceManagement.vue?vue&type=template&id=51450986"
import script from "./serviceManagement.vue?vue&type=script&lang=js"
export * from "./serviceManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports